export default "__VITE_ASSET__nXAwHX7$__"